import React from 'react';
import { Helmet } from 'react-helmet';
import contents from './content';
import styles from './style.module.css';

const ContentWrapper = ({ title, detail }) => (
  <section className={styles.ContentWrapper}>
    <h5 className={styles.sectionTitle}>{title}</h5>
    <div className={styles.sectionBody}>
      {detail.map((paragraph, index) => (
        <div key={index} className={styles.paragraph} dangerouslySetInnerHTML={{ __html: paragraph }} />
      ))}
    </div>
  </section>
);

const JournalerPrivacyPolicy = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Journaler Privacy Policy | AEM Technologies</title>
        <meta
          name='description'
          content='Privacy policy for Journaler by AEM Technologies Pty Ltd, including collection, use, and protection of personal information.'
        />
      </Helmet>
        <div className={styles.policyPageWrapper}>
        <div className='row justify-content-center'>
          <h1 className={styles.titleBorder}>PRIVACY POLICY</h1>
        </div>

        <div className='container'>
          <h4 className='pt-5 pb-4'>AEM Technologies Pty Ltd</h4>
          {contents.map((contents, index) => (
            <ContentWrapper key={index} title={contents.title} detail={contents.detail} />
          ))}
          <p className='pt-3 pb-5'>18 March 2026</p>
        </div>
      </div>
    </>
  );
};

export default JournalerPrivacyPolicy;
